import { render, staticRenderFns } from "./table-note.vue?vue&type=template&id=d125ee70&scoped=true&"
import script from "./table-note.vue?vue&type=script&lang=js&"
export * from "./table-note.vue?vue&type=script&lang=js&"
import style0 from "./table-note.vue?vue&type=style&index=0&id=d125ee70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d125ee70",
  null
  
)

export default component.exports